/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-array-index-key */

import React from 'react';

const CurrentWeekReport = (props) => (
  <div className="sub-nav">
    <div className="sub-nav-buttons">
      <div className="sub-title">
        <h5>{props.data.name}</h5>
      </div>
      {props.data.items.map((item, i) => (
        <a
          key={`${item.name}_${i}`}
          onClick={item.onClick}
          // here we check if the selected id is the same as the id of the element, that way we found out if we
          // should put the selected class in the menu. So make sure everytime the ids of the menu items are the same
          // as the this.state.tablesShown number used with the calling of the this.setTables function in the reports
          // layout, if the ids are not the same, there will never be 'selected' item from the menu
          className={item.id === props.selectedId ? 'selected' : null}
        >
          {item.name}
        </a>
      ))}
    </div>
  </div>
);

export default CurrentWeekReport;
